export enum InvoiceStatus {
  Pending = "pending",
  Paid = "paid",
  Processing = "processing",
  PastDue = "past_due",
  Failed = "failed",
}

export enum InvoiceItemOrigin {
  Plan = "plan",
  PlanTrial = "plan_trial",
  SetupFee = "setup_fee",
  AddOn = "add_on",
  AddOnTrial = "add_on_trial",
  OneTime = "one_time",
  Debit = "debit",
  Credit = "credit",
  Coupon = "coupon",
  CarryForward = "carryforward",
}

export interface IInvoiceItem {
  description: string;
  quantity: number;
  origin: InvoiceItemOrigin;
  totalAmountCents: number;
  unitAmountCents: number;
}

export interface IInvoice {
  id: number;
  createdAt: Date;
  status: InvoiceStatus;
  currency: string;
  totalCents: number;
  items: IInvoiceItem[];
}
